package team.platforma.chat_di

import com.platforma.chat_domain.di.chatDomainModule
import team.platforma.chat_data.di.chatDataModule
import team.platforma.chat_data.di.chatDatabaseModule
import team.platforma.chat_presentation.di.chatPresentationModule

fun chatDiProvider() = listOf(
    chatDatabaseModule,
    chatDataModule,
    chatDomainModule,
    chatPresentationModule
)